import Vue from 'vue'
require('dotenv').config();

import App from './App.vue'
import VueAnimated from '@codekraft-studio/vue-animated'
import VueSwal from 'vue-swal'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import axios from 'axios'

window.axios = axios;

Vue.use(Vuex)
Vue.use(VueSwal)
Vue.use(VueAnimated)

const persist = createPersistedState({
  key: "konnexion",
  paths: ["user", "connected", "permissions"],
  getState: (key, storage) => {
    let value = storage.getItem(key);
    if (!value) {
      return undefined;
    }
    value = JSON.parse(value);
    return value;
  }
});


const store = new Vuex.Store({
  plugins: [persist],
  mutations: {
    logout(state){
      state.user = null;
      state.permissions = null;
      state.connected = false;
    },
    logged(state,payload){
      state.user = payload.user;
      state.permissions = payload.permissions;
      state.connected = true;
    }
  },
  getters:{
    user(state){
      return state.user;
    },
    permissions(state){
      return state.permissions;
    },
    connected(state){
      return state.connected;
    }
  }
})

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App),
}).$mount('#app')
